import { api } from "../utils/axios";

/* ==============================
   BOOKING APIs
   ============================== */

/**
 * Create a new booking
 * @param {Object} bookingData - userRef, domeRef, sessionRef, date, name, email, phone
 */
export const createBooking = async (bookingData) => {
  try {
    const response = await api.post("/bookings", bookingData);
    return response.data.data;
  } catch (error) {
    console.error("Error creating booking:", error);
    throw error;
  }
};

/**
 * Fetch all bookings for a specific dome and optional date with pagination
 * @param {string} domeId
 * @param {string} [date] - Optional YYYY-MM-DD
 * @param {number} [page=1] - Current page number
 * @param {number} [limit=10] - Number of records per page
 */
export const fetchBookingsByDomeAndDate = async (domeId, date = "", page = 1, limit = 10) => {
  console.log("🚀 ~ fetchBookingsByDomeAndDate ~ date:", date);
  console.log("🚀 ~ fetchBookingsByDomeAndDate ~ page:", page);
  console.log("🚀 ~ fetchBookingsByDomeAndDate ~ limit:", limit);

  try {
    const endpoint = `/bookings/dome/${domeId}/date`;
    console.log("📡 Fetching bookings from:", endpoint);

    const response = await api.post(endpoint, { date, page, limit }); // ✅ send pagination + date in body

    console.log("✅ Bookings fetched:", response);
    return response.data.data; // contains { bookings, pagination }
  } catch (error) {
    console.error("❌ Error fetching bookings by dome and date:", error);
    throw error;
  }
};


/**
 * Fetch all bookings for a specific user
 * @param {string} userId
 */
export const fetchBookingsByUser = async (userId) => {
  try {
    const response = await api.get(`/bookings/user/${userId}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching bookings by user:", error);
    throw error;
  }
};

/**
 * Fetch upcoming bookings for a specific user
 * @param {string} userId
 */
export const fetchUpcomingBookings = async (userId) => {
  try {
    const response = await api.get(`/bookings/user/${userId}/upcoming`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching upcoming bookings:", error);
    throw error;
  }
};

/**
 * Fetch past bookings for a specific user
 * @param {string} userId
 */
export const fetchPastBookings = async (userId) => {
  try {
    const response = await api.get(`/bookings/user/${userId}/past`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching past bookings:", error);
    throw error;
  }
};

/**
 * Delete a booking by ID
 * @param {string} id - booking ID
 */
export const deleteBooking = async (id) => {
  try {
    const response = await api.delete(`/bookings/${id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error deleting booking:", error);
    throw error;
  }
};

/**
 * Update booking contact info (name, email, phone)
 * @param {string} id - booking ID
 * @param {Object} data - { name?, email?, phone? }
 */
export const updateBookingContact = async (id, data) => {
  try {
    const response = await api.patch(`/bookings/${id}/contact`, data);
    return response.data.data;
  } catch (error) {
    console.error("Error updating booking contact:", error);
    throw error;
  }
};

/**
 * Toggle booking status between 'booked' and 'cancelled'
 * @param {string} id - booking ID
 */
export const toggleBookingStatus = async (id) => {
  try {
    const response = await api.patch(`/bookings/${id}/status`);
    return response.data.data;
  } catch (error) {
    console.error("Error toggling booking status:", error);
    throw error;
  }
};

/**
 * Approve a booking (called by Host)
 * @param {string} id - booking ID
 */
export const approveBooking = async (id) => {
  try {
    const response = await api.patch(`/bookings/${id}/host-approve`);
    return response.data.data;
  } catch (error) {
    console.error("Error approving booking:", error);
    throw error;
  }
};

/**
 * Create a booking from host panel (private/corporate domes only)
 * @param {string} domeRef - dome ObjectId
 * @param {string} sessionRef - session ObjectId
 * @param {string} date - date string YYYY-MM-DD
 */
export const createHostPanelBooking = async (domeRef, sessionRef, date) => {
  try {
    const response = await api.post("/bookings/host-panel", { domeRef, sessionRef, date });
    return response.data.data;
  } catch (error) {
    console.error("Error creating host panel booking:", error);
    throw error;
  }
};
